var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "\n        <div class=\"iframeWr invisible\">\n            <iframe id=\"iframeViewer\" frameBorder=\"0\" scrolling=\"no\" type=\"application/pdf\"></iframe>\n        </div>\n\n        <div id=\"dlCancelledPDF\" class=\"hide\">\n            <div>\n                <span class=\"icon-attention-1\"></span>\n                Loading of PDF cancelled by user\n            </div>\n            <button id=\"reloadPDF\" class=\"btn\">\n                <span class=\"icm-file-pdf3\"></span>\n                Load PDF\n            </button>\n        </div>\n\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"FV-pdfMode FV-paneContentWr\">\n\n"
    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.docHasNoPDFRenderablePgs : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewModes/pdfMode/pdfContainer.hbs
 ** module id = 479
 ** module chunks = 0
 **/